/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationTransitionalClientTeamUpdateRequest
 */
export interface OrganizationTransitionalClientTeamUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationTransitionalClientTeamUpdateRequest
     */
    transitionalClientTeamId: string;
}

/**
 * Check if a given object implements the OrganizationTransitionalClientTeamUpdateRequest interface.
 */
export function instanceOfOrganizationTransitionalClientTeamUpdateRequest(value: object): value is OrganizationTransitionalClientTeamUpdateRequest {
    if (!('transitionalClientTeamId' in value) || value['transitionalClientTeamId'] === undefined) return false;
    return true;
}

export function OrganizationTransitionalClientTeamUpdateRequestFromJSON(json: any): OrganizationTransitionalClientTeamUpdateRequest {
    return OrganizationTransitionalClientTeamUpdateRequestFromJSONTyped(json, false);
}

export function OrganizationTransitionalClientTeamUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationTransitionalClientTeamUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transitionalClientTeamId': json['transitionalClientTeamId'],
    };
}

export function OrganizationTransitionalClientTeamUpdateRequestToJSON(value?: OrganizationTransitionalClientTeamUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'transitionalClientTeamId': value['transitionalClientTeamId'],
    };
}

